
var Model = require("../types/Model.js");
var xtend = require("xtend");

module.exports = new Model({
	name: "livechatsessionhistory",
	init: init,
	uninit: uninit,
	listeners: listeners,
	triggers: triggers,

	recalculate: recalculate,
	setIsMember: setIsMember,
	addPerson: addPerson,
	refresh: refresh,
	trackSessions: trackSessions,
	appendSessions: appendSessions,
	setEnd: setEnd,
	addSession: addSession
});

function init(){
	this._end = true;
	this._page = 0;
	this._rawList = [];
	this._creating = false;
	this._group = null;
	this._tracker = this.dispatcher.createTracker();
	this.push({
		list: [],
		isEnd: true,
		page: 0
	});
}

function uninit(){
	this._tracker.off();
	this._tracker = null;
}

function triggers(){
	return {
		more: loadMore,
		reset: reset
	};
}


function listeners(){
	return {
		"activelivechatgroup:viewing": handle_active_updated,
		"connectivity:online": refresh,
		"people:updated": Model.makeRecalculator("people"),
		"orggroup:updated": handle_org_group_update
	};
}

function recalculate(){
	var people = this._people;
	var sessions = this._rawList;
	var group = this._group;
	var end = this._end;
	var page = this._page;

	if(!group) return;

	var newSessions = sessions.map(function(session){
		var who = session.who;
		var owner = session.owner;
		var newWho = people[who];
		var newOwner = people[owner];

		var update = {};
		if(newOwner)
			update.owner = newOwner;
		if(newWho)
			update.who = newWho;

		return xtend(session, update);
	}).sort(sortByTime);

	this._list = newSessions;
	this.extend({
		list: newSessions,
		isEnd: end,
		page: page
	});
}


function handle_active_updated(group){
	if(!group) return;
	var groupId = group._id;
	this._group = groupId;


	this.setIsMember(group);
	this.refresh();
}

function refresh(){
	var group = this._group;
	var page = 0;

	if(!group) return;

	return this.api.livechat.session.listHistory(page, group)
		.then(addPeople.bind(this))
		.then(setSessions.bind(this))
		.then(trackSessions.bind(this));
}

function setSessions(list){
	this.setEnd(list);
	this.addSession(list.map(function(session){
		return session._id;
	}));
	this._rawList = list;
	this.recalculate();
}

function appendSessions(list){
	this.setEnd(list);
	this.addSession(list.map(function(session){
		return session._id;
	}));
	this._rawList = this._rawList.concat(list);
	this.recalculate();
}

function addSession(session){
	this.emit("livechatlatestmessages:trigger:add", session);
}

function trackSessions(){
	var group = this._group;
	var tracker = this._tracker;
	var orgGroup = this._orgGroup;
	var isMember = this._isMember;

	if(!group || !orgGroup) return;

	var prefix = "mqtt:$/livechat/";
	if(isMember)
		prefix = "mqtt:orggroup/" + orgGroup + "/livechat/";

	tracker.off();
	tracker.on(prefix + group + "/session/closed", handle_session_ended.bind(this));
}

function handle_session_ended(session){
	var current = this._rawList;

	if(!(session.who === this.config.id || session.owner === this.config.id))
		return;

	var newList = current.concat(session);

	this.addSession(session._id);
	this._rawList = newList;
	this.recalculate();
}

function addPeople(list){
	this.addPerson(list.reduce(function(acc, session){
		if(acc.indexOf(session.who) === -1) acc = acc.concat(session.who);
		if(acc.indexOf(session.owner) === -1) acc = acc.concat(session.owner);
		return acc;
	}, []));
	return list;
}

function addPerson(person){
	this.emit("people:trigger:add", {
		lean: true,
		who: person
	});
}

function setIsMember(group){
	this._isMember = group.members.indexOf(this.config.id) !== -1;
}

function handle_org_group_update(group){
	this._orgGroup = group;
	this.trackSessions();
}

function loadMore(){
	var group = this._group;
	var page = ++this._page;

	this.emit("usermetrics:trigger:track", "load more livechat session history", {
		"livechat group": group
	});

	return this.api.livechat.session.listHistory(page, group)
		.then(addPeople.bind(this))
		.then(appendSessions.bind(this))
		.then(trackSessions.bind(this));
}

function setEnd(list){
	this._end = list.length < 32;
}

function sortByTime(a, b){
	return new Date(b.updated_at) - new Date(a.updated_at);
}

function reset(){
	this._end = true;
	this._page = 0;
	this._rawList = [];
	this._creating = false;
	this._group = null;
	this.push({
		list: [],
		isEnd: true,
		page: 0
	});
	this.emit("usermetrics:trigger:track", "close livechat session history");
}
